import EnterLayout from 'components/enter2026/EnterLayout';
import MainLayout from 'components/layout/MainLayout';
import { GetServerSideProps } from 'next';
import styles from './checkouta.module.css';
import { ASSET_PREFIX, runningInProduction } from 'utils/constants';
import { useRouter } from 'next/router';
import { useEffect } from 'react';
import { useEnterStore } from 'hooks/stores/useEnterStore';
import { observer } from 'mobx-react-lite';
import OrderSummaryRows from 'components/enter2026/OrderSummaryRows';
import OrderSummaryCosts from 'components/enter2026/OrderSummaryCosts';
import { PlasmicEnterCheckout } from 'components/payments/PlasmicEnterCheckout';
import ShoppingCart from '../components/svg/ShoppingCart.svg';
import { PromoCodeEntry } from 'components/enter/order-summary/PromoCodeEntry';
import TicketStack from 'components/dashboard/EntriesAndStats/TicketStack';

interface EnterNowCheckoutProps {}

const EnterNowCheckout = observer((props: EnterNowCheckoutProps) => {
  const enterStore = useEnterStore();

  useEffect(() => {
    (async () => enterStore.handleContinueToPayment())();
  }, []);

  return (
    <MainLayout limitItemWidths>
      <EnterLayout
        sidePanel={
          <div className={styles.sidePanel}>
            <h2 className={'aboutUsTypographyHeaderMedium ' + styles.heading}>
              <ShoppingCart />
              <span>Your order</span>
            </h2>
            <hr />
            <p>
              Your numbers look great!
              <br />
              Here they are once more
            </p>
            <div className={styles.entryContainer}>
              <TicketStack
                entries={enterStore.lines}
                withLoadingSkeleton={false}
                expanded
                hideExpandButton
              />
            </div>
            <hr />
            <div>
              {/* Placed in a separate DIV so that it can be centered without being full width */}
              <OrderSummaryRows showDays={true} />
            </div>
            <hr />
            <PromoCodeEntry />
            <OrderSummaryCosts />
            <hr />
            <strong className={styles.cancelText}>👋 Cancel anytime 👋</strong>
          </div>
        }
        sidePanelBackground={'GREY'}
        stepIcon={null}
        stepIntroText={null}
        stepName="Payment"
        stepIndex={5}
      >
        <div className={styles.mainPanel}>
          <PlasmicEnterCheckout />
        </div>
        <div className={styles.logos}>
          <img
            src={`${ASSET_PREFIX}/images/enter/payment-icons/secure-checkout.svg`}
            alt=""
          />
          <img
            src={`${ASSET_PREFIX}/images/enter/payment-icons/privacy-protected.svg`}
            alt=""
          />
          <img
            src={`${ASSET_PREFIX}/images/enter/payment-icons/trustpilot.svg`}
            alt=""
          />
        </div>
      </EnterLayout>
    </MainLayout>
  );
});

export default EnterNowCheckout;

export const getServerSideProps: GetServerSideProps<
  EnterNowCheckoutProps
> = async (_ctx) => {
  return {
    props: {},
  };
};
